import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import levels from '../../data/Levels';
import {getMaxLevel, handleAddString, handleBestScore, handleMaxLevel} from '../../services/GameServices';
import GameOverPopUp from '../Popups/GameOverPopUp';
import {AppContainer, CurrentNumber, HeaderContainer, MiddleContainer, MiddleContainer1, MiddleContainer2, MiddleContainer7, MiddleContainer7Row, MiddleContainer7Row2, MiddleContainer7RowCell, MiddleContainer7RowCellAnimation, NumberItem, NumberList, NumberValue, NumberValue2, SquareButtonLimit} from '../Styles';
import GameHeader3 from './GameHeader3';
import Grid from './Grid';


let temp = false;

/*************  ✨ Codeium Command ⭐  *************/
/**
 * A Game component that renders the game UI and handles the game logic.
/******  d77f61af-82c3-4c60-9f61-91afcad92dd1  *******/
const Game = ({level = levels[getMaxLevel() - 5], id = null}) => {

  const [min, setMin] = useState(1);
  const [max, setMax] = useState(level.range);

  const [numbers3, setNumbers3] = useState({
    numbers: Array.from({length: level.options}, () => 0),
    visibility: Array.from({length: level.options}, () => "show"),
    nList: Array.from({length: level.options}, (_, i) => i)
  });

  const [randomNumber, setRandomNumber] = useState(() => getRandomNumber(min, max, numbers3.numbers));
  const [correct, setCorrect] = useState(level.options);
  const [isNumbersEnabled, setIsNumbersEnabled] = useState(true);

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const [showAdditionPopup, setShowAdditionPopup] = useState(false);
  const [additionLimit, setAdditionLimit] = useState(3);
  const [currentNumber, setCurrentNumber] = useState(() => Math.floor(Math.random() * 100) + 1);
  const [isSpinning, setIsSpinning] = useState(false);


  const playAgain = () => {
    setNumbers3(
      {
        numbers: Array.from({length: level.options}, () => 0),
        visibility: Array.from({length: level.options}, () => "show"),
        nList: Array.from({length: level.options}, (_, i) => i)
      }
    )

    setCorrect(level.options);
    setRandomNumber(() => getRandomNumber(min, max, numbers3.numbers));
    setIsSettingsOpen(false);
    setStatus(null);
    setShowAdditionPopup(false);
    setAdditionLimit(3);
    setIsNumbersEnabled(true);
    setCurrentNumber(() => Math.floor(Math.random() * 100) + 1);
    setIsSpinning(false);
  };

  const updateCurrentNumber = (addition) => {
    setAdditionLimit(prev => prev - 1);
    setShowAdditionPopup(false)
    setCurrentNumber(prev => prev + addition);
  };

  const updateNumberAtPosition = (position, newValue) => {
    setIsNumbersEnabled(false);
    setTimeout(startSpin, 500);

    setNumbers3(prevState => {
      const updatedNumbers = [...prevState.numbers];
      const updatedVisibility = [...prevState.visibility];
      const mList = [...prevState.nList];

      // Update the specific position
      updatedNumbers[position] = newValue;
      updatedVisibility[position] = "hidden";
      // Return the new state
      return {
        numbers: updatedNumbers,
        visibility: updatedVisibility,
        nList: mList
      };
    });
    setRandomNumber(getRandomNumber(min, max, numbers3.numbers));
    setCorrect(prevCorrect => prevCorrect - 1);
    handleBestScore(correct - 1);

  };

  useEffect(() => {
    let newList = numbers3.numbers.filter(number => number !== 0);

    if (!isIncreasing(newList)) {
      console.log("Game Over")
      setStatus("YouLost");
      setIsSettingsOpen(true);
    }
    else if (correct === 0) {
      console.log("Game Over")
      setStatus("YouWon");
      handleMaxLevel(level.nextLevel)
      handleAddString(level.id);
      setIsSettingsOpen(true);
    }

  }, [randomNumber]);

  const shuffled = Array.from({length: 100}, (_, index) => index + 1);
  const shuffledNumbers = shuffleArray(shuffled);

  const startSpin = () => {
    setIsSpinning(true);

    // The interval will simulate the reel spinning by changing the number every 100ms
    const spinInterval = setInterval(() => {
      setCurrentNumber(shuffledNumbers[Math.floor(Math.random() * 100)]); // Spin through numbers 1 to 100
    }, 100);
    // Stop spinning after 3 seconds
    setTimeout(() => {
      clearInterval(spinInterval);
      setIsSpinning(false);
      setIsNumbersEnabled(true);

      // Set the reel to a random number when it stops
      const randomNumber = Math.floor(Math.random() * shuffledNumbers.length) + 1;
      setCurrentNumber(randomNumber);
    }, 3000); // Spins for 3 seconds
  };

  return (
    <AppContainer>
      <GameOverPopUp status={status} setIsSettingsOpen={setIsSettingsOpen} isSettingsOpen={isSettingsOpen} playAgain={playAgain} />
      <HeaderContainer>
        <GameHeader3 playAgain={playAgain} levelNumber={level.options} />
      </HeaderContainer>
      <MiddleContainer>
        <MiddleContainer1>
          <NumberList>
            {numbers3.nList.map(number => (
              <NumberItem key={number}>
                {numbers3.numbers[number] === 0
                  ? <NumberValue2>{`${number + 1}.`}</NumberValue2>
                  : (
                    <>
                      <NumberValue2>{`${number + 1}.`}</NumberValue2>
                      <NumberValue>{numbers3.numbers[number]}</NumberValue>
                    </>
                  )
                }
              </NumberItem>
            ))}
          </NumberList>
        </MiddleContainer1>
        <MiddleContainer2>
          <CurrentNumber>
            {currentNumber}
          </CurrentNumber>

        </MiddleContainer2>
        <MiddleContainer7>
          <MiddleContainer7Row2>
            <SquareButtonLimit />
            <SquareButtonLimit>{additionLimit} left</SquareButtonLimit>
          </MiddleContainer7Row2>
          {
            !showAdditionPopup ? (
              additionLimit !== 0 ? (
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell invisible="true" />
                  <MiddleContainer7RowCellAnimation animation="true" onClick={() => setShowAdditionPopup(true)}  >
                    +/-
                  </MiddleContainer7RowCellAnimation>
                </MiddleContainer7Row>
              ) : (
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell invisible="true" />
                  <MiddleContainer7RowCell backgroundcolor="#B0B0B0"  >
                    +/-
                  </MiddleContainer7RowCell>
                </MiddleContainer7Row>
              )
            ) : (
              <>
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell invisible="true" />
                  <MiddleContainer7RowCell onClick={() => setShowAdditionPopup(false)} >
                    x
                  </MiddleContainer7RowCell>
                </MiddleContainer7Row>
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(-1)} >
                    -1
                  </MiddleContainer7RowCell>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(1)} >
                    +1
                  </MiddleContainer7RowCell>
                </MiddleContainer7Row>
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(-10)} >
                    -10
                  </MiddleContainer7RowCell>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(10)} >
                    +10
                  </MiddleContainer7RowCell>
                </MiddleContainer7Row>
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(-20)} >
                    -20
                  </MiddleContainer7RowCell>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(20)} >
                    +20
                  </MiddleContainer7RowCell>
                </MiddleContainer7Row>
                <MiddleContainer7Row>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(-50)} >
                    -50
                  </MiddleContainer7RowCell>
                  <MiddleContainer7RowCell onClick={() => updateCurrentNumber(50)} >
                    +50
                  </MiddleContainer7RowCell>
                </MiddleContainer7Row>
              </>
            )
          }

        </MiddleContainer7>
      </MiddleContainer>
      <Grid onSelect={updateNumberAtPosition} isEnabled={isNumbersEnabled} numbers2={numbers3} randomNumber={currentNumber} status={status} />
      {/* <RandomizeButton text={"Evaluate " + evaluation } onClick={() => id ? triggerOnlineRecalculation() : triggerRecalculation()}/> */}
    </AppContainer>


  );
};

export default Game;

function getRandomNumber(min, max, numbers) {
  let randomNumber;

  do {
    randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (numbers.includes(randomNumber));

  return randomNumber;
}


function getRandomNumber6(min, max, numbers) {
  let randomNumber;
  let valid = false;

  do {
    // Generate a random number between min and max
    randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

    valid = false;

    // Check if the random number fits into any gap
    for (let i = 0; i < numbers.length - 1; i++) {
      if (numbers[i] === 0 && randomNumber < numbers[i + 1]) {
        valid = true;
        break;
      }
    }

  } while (numbers.includes(randomNumber) || !valid);

  return randomNumber;
}

function getRandomNumber88(min, max, numbers) {
  let randomNumber;
  let valid = false;

  do {
    // Generate a random number between min and max
    randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

    valid = false;

    // Check if the random number fits into any gap
    for (let i = 0; i < numbers.length; i++) {
      // Check if the current number is 0 (indicating a gap)
      if (numbers[i] === 0) {
        // Ensure the random number fits within the bounds of the gap
        // Only check if there is a next number to compare
        if (i < numbers.length - 1 && randomNumber < numbers[i + 1]) {
          valid = true;
          break;
        }
        // If it's the last number, we can just check the min/max bounds
        if (i === numbers.length - 1 && randomNumber > numbers[i - 1]) {
          valid = true;
          break;
        }
      }
    }

  } while (numbers.includes(randomNumber) || !valid);

  return randomNumber;
}



function isIncreasing(list) {
  for (let i = 1; i < list.length; i++) {
    if (list[i] < list[i - 1]) {
      return false; // Return false if the next value is less than the current value
    }
  }
  return true; // Return true if no such case is found
}

const Reel = styled.div`
  font-size: 72px;
  border: 5px solid black;
  border-radius: 10px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
`;

const SpinButton = styled.button`
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  border-radius: 5px;
  border: none;
  background-color: #4CAF50;
  color: white;
  &:disabled {
    background-color: #999;
    cursor: not-allowed;
  }
`;

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  }
  return array;
}

{/* <SpinButton onClick={startSpin} disabled={isSpinning}>
            {isSpinning ? 'Spinning...' : 'Spin Reel'}
          </SpinButton> */}


{/* <MiddleContainer3>
  <SquareButtonLimit>{additionLimit} left</SquareButtonLimit>
  {
    !showAdditionPopup ? (
      additionLimit !== 0 ? (
        <SquareButton onClick={() => setShowAdditionPopup(true)} >+/-</SquareButton>
      ) : (
        <SquareButton backgroundcolor="#B0B0B0" >+/-</SquareButton>
      )
    ) : (
      <>
        <SquareButton onClick={() => setShowAdditionPopup(false)} >x</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(1)} >+1</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(-1)} >-1</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(10)} >+10</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(-10)} >-10</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(20)}>+20</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(-20)}>-20</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(50)}>+50</SquareButton>
        <SquareButton onClick={() => updateCurrentNumber(-50)}>-50</SquareButton>
      </>
    )
  }
</MiddleContainer3> */}